import React from 'react';

const KanbanBoard = ({ tasks, getUserName }) => {
    const statuses = ['Pending', 'In Progress', 'Completed'];

    const getStatusColor = (status) => {
        switch (status) {
            case 'Pending': return '#fce8e6'; // Red-ish
            case 'In Progress': return '#fff8e1'; // Yellow-ish
            case 'Completed': return '#e6f4ea'; // Green-ish
            default: return '#f1f3f4';
        }
    };

    return (
        <div style={{ display: 'flex', gap: '1rem', overflowX: 'auto', paddingBottom: '1rem' }}>
            {statuses.map(status => {
                const statusTasks = tasks.filter(t => t.Status === status || (status === 'Pending' && !statuses.includes(t.Status)));

                return (
                    <div key={status} style={{
                        flex: '1 0 300px',
                        background: '#f8fafc',
                        borderRadius: '12px',
                        padding: '1.25rem',

                    }}>
                        <div style={{
                            marginBottom: '1.25rem',
                            padding: '0.6rem 1rem',
                            borderRadius: '8px',
                            background: status === 'Completed' ? '#dcfce7' : status === 'In Progress' ? '#fef9c3' : '#fee2e2',
                            color: status === 'Completed' ? '#166534' : status === 'In Progress' ? '#854d0e' : '#991b1b',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            fontWeight: 700,
                            fontSize: '0.9rem'
                        }}>
                            <span>{status}</span>
                            <span style={{
                                background: 'rgba(255,255,255,0.6)',
                                padding: '0.15rem 0.6rem',
                                borderRadius: '999px',
                                fontSize: '0.75rem',
                                color: 'inherit'
                            }}>
                                {statusTasks.length}
                            </span>
                        </div>

                        <div className="kanban-column-scroll" style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '0.75rem',
                            maxHeight: '400px',
                            overflowY: 'auto',
                            paddingRight: '4px'
                        }}>
                            {statusTasks.map(task => (
                                <div key={task.TaskID} style={{
                                    background: 'white',
                                    padding: '1.25rem',
                                    borderRadius: '10px',
                                    boxShadow: '0 4px 12px rgba(15, 23, 42, 0.04)',
                                    border: '1px solid #f1f5f9',
                                    borderLeft: `4px solid ${getStatusColor(task.Status)}`
                                }}>
                                    <div style={{ fontWeight: 500, marginBottom: '0.5rem', color: '#202124' }}>{task.Title}</div>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '0.8rem', color: '#5f6368' }}>
                                        <span>{getUserName ? getUserName(task.AssigneeID) : (task.AssigneeID || 'Unassigned')}</span>
                                        {task.Priority && (
                                            <span style={{
                                                padding: '2px 6px',
                                                borderRadius: '4px',
                                                background: '#eef2ff',
                                                color: '#4f46e5',
                                                fontWeight: 500
                                            }}>
                                                {task.Priority}
                                            </span>
                                        )}
                                    </div>
                                    {task.DueDate && (
                                        <div style={{ marginTop: '0.5rem', fontSize: '0.75rem', color: '#ea4335' }}>
                                            Due: {new Date(task.DueDate).toLocaleDateString()}
                                        </div>
                                    )}
                                </div>
                            ))}
                            {statusTasks.length === 0 && (
                                <div style={{ textAlign: 'center', color: '#aaa', fontStyle: 'italic', fontSize: '0.9rem', padding: '1rem' }}>
                                    No tasks
                                </div>
                            )}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default KanbanBoard;
